import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-gap: 83px 18px;
  margin: 0 0 40px 0;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media (max-width: 414px) {
    grid-template-columns: repeat(2, 1fr);
  }

  & button,
  & div {
    margin: 0;
  }

  & a {
    width: 100%;
  }
`;
